import { render } from "./IAModel.vue?vue&type=template&id=95de920c&scoped=true"
import script from "./IAModel.vue?vue&type=script&lang=js"
export * from "./IAModel.vue?vue&type=script&lang=js"

import "./IAModel.vue?vue&type=style&index=0&id=95de920c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95de920c"]])

export default __exports__